import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import dayjs from 'dayjs/esm';

@Component({
  selector: 'app-date-range-picker',
  templateUrl: './date-range-picker.component.html',
  styleUrls: ['./date-range-picker.component.scss'],
})
export class DateRangePickerComponent implements OnInit {
  @Input() minDate: any;
  @Input() maxDate: any;
  @Input() defaultValue: any;
  @Output() onDateValueChange = new EventEmitter<any>();
  @Input() dropPosition = "up";
  @Input() customReadOnly = false;
  datePickerId: string = this.generateRandomId();
  
  selectedDate: any = {};
  ranges: any = {
    'This Week': [dayjs().startOf('week'), dayjs().endOf('week')],
    'Last Week': [dayjs().subtract(1, 'week').startOf('week'), dayjs().subtract(1, 'week').endOf('week')],
    'Past 2 Weeks': [dayjs().subtract(2, 'weeks').startOf('week'), dayjs().subtract(1, 'weeks').endOf('week')],
    'This Month': [dayjs().startOf('month'), dayjs().endOf('month')],
    'Last Month': [dayjs().subtract(1, 'month').startOf('month'), dayjs().subtract(1, 'month').endOf('month')],
    'This Year': [dayjs().startOf('year'), dayjs().endOf('year')],
    'Last Year': [dayjs().subtract(1, 'year').startOf('year'), dayjs().subtract(1, 'year').endOf('year')]
  }

  constructor() {}
  
  ngOnInit(): void {
    this.selectedDate = this.defaultValue;
  }

  generateRandomId(): string {
    return 'id-' + Math.random().toString(36).substr(2, 9);
  }

  onDatesUpdate(event: any) {
    if (event.startDate && event.endDate) {
      const timezoneOffset = new Date().getTimezoneOffset();
      const startOffset = this.getStandardTimezoneOffset(event.startDate.toDate());
      const endOffset = this.getStandardTimezoneOffset(event.endDate.toDate());
      const absoluteTimeZoneMinsStartOffset = Math.abs(startOffset);
      const absoluteTimeZoneMinsEndOffset = Math.abs(endOffset);
      
      if (timezoneOffset > 0) {
        const adjustedEndDate = dayjs(event.endDate).add(endOffset, 'minute').toDate();
        const adjustedStartDate = dayjs(event.startDate).add(startOffset, 'minute').toDate();
        //converting to UTC
        this.onDateValueChange.emit({
          toDate: adjustedEndDate, 
          fromDate: adjustedStartDate 
        });
      } 
      else {
        const adjustedEndDate = dayjs(event.endDate).subtract(absoluteTimeZoneMinsEndOffset, 'minute').toDate();
        const adjustedStartDate = dayjs(event.startDate).subtract(absoluteTimeZoneMinsStartOffset, 'minute').toDate();
        
        this.onDateValueChange.emit({
          toDate: adjustedEndDate,  
          fromDate: adjustedStartDate 
        });
      }
    }
  }
  getStandardTimezoneOffset(date: Date): number {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getMonth(), date.getDate())).getTimezoneOffset();
  }
}
